import React, { Fragment, useEffect, useState } from "react";
import TitleBox from "../../components/common/TitleBox";
import SlotCenter from "../../components/Slot/SlotCenter";
import Headbar from "../../components/Layout/Headbar";
import {
  getGameLaunch,
  getGameList,
  getImages,
  getlistImgPath,
  getLobbylist,
  getTitle,
  isEmpty,
  toastr,
} from "../../common/cores";
import { SetPageLoading } from "../../common/actions/pageAction";
import connect from "react-redux/lib/connect/connect";
import Footbar, { MobileFootbar } from "../../components/Layout/Footbar";
import { isMobile } from "../../utils/utils";

const Slot = (props) => {
  const { isAuthenticated, user, casinoStatus } = props;

  const [slotLists, setSlotLists] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [gameLists, setGameLists] = useState([]);
  const [imgLists, setImgLists] = useState([]);
  const [search, setSearch] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  const gameType = "Slot";

  const getLoginLists = () => {
    props.SetPageLoading(true);
    const params = {
      type: gameType,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      console.log("tet", data.lobbyList);
      setSlotLists(data.lobbyList);
      props.SetPageLoading(false);
    });
  };

  const onClickOpenModal = (list) => {
    if (!props.isAuthenticated)
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    props.SetPageLoading(true);
    setGameLists([]);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      vendor: list.vendor,
      // api: api
    };

    getGameList(params).then((data) => {
      // setApi(data.api);
      getImages(data.result, data.api).then((images) => {
        setImgLists(images);
        setGameLists(data.result);
        setOpenModal(!openModal);
        props.SetPageLoading(false);
      });
    });
  };

  const onClickList = (list) => {
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  const onClickCloseModal = (list) => {
    // console.log(list);
    setOpenModal(!openModal);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
      window.location.href = "/";
    }
    getLoginLists("Slot");
  }, [isAuthenticated]);

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  const normalImage = "Logo.jpg";

  const getModalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div className="container main_section">
            <div
              className="main_visual"
              style={{ display: isMobile() ? "none" : "block" }}
            >
              <div className="notice_area">
                <div className="inner">
                  <p className="tit">
                    {" "}
                    <img src="/r/front/img/main/txt_notice.jpg" alt="notice" />
                    <span className="" langkey="new_theme.common.notification">
                      {isEmpty(window.lang["공지"])
                        ? "공지"
                        : window.lang["공지"]}
                    </span>{" "}
                  </p>
                  <div className="marquee">
                    <div>
                      <p
                        className="txt"
                        id="lineMsg"
                        style={{ color: "rgb(255, 255, 255)" }}
                      >
                        {isEmpty(
                          window.lang[
                            "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                          ]
                        )
                          ? "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                          : window.lang[
                              "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                            ]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="contents">
              <div id="gameList">
                <div className="game_list1" id="category1830">
                  <div className="sport inner">
                    <div className="titlebox">
                      <h4>
                        {isEmpty(window.lang["슬롯"])
                          ? "슬롯"
                          : window.lang["슬롯"]}{" "}
                      </h4>
                    </div>
                    <div className="game_list_wrap" data-cat="1830">
                      <ul className="row">
                        {slotLists.map((list, index) => {
                          return (
                            <li
                              className="col-6 col-md-3"
                              key={index}
                              data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                              data-game-title="빅 배스 보난자"
                              data-game-title-en="Big Bass Bonanza"
                              data-game-code="28"
                              data-game-meta-code="244"
                              data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                              data-game-video-url=""
                              data-event_game_yn="N"
                              data-game-child-seq="11605"
                              onClick={() => onClickOpenModal(list)}
                            >
                              {" "}
                              <span className="G005001"></span>{" "}
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                style={{
                                  width: "100%",
                                  // height: "150px",
                                  objectFit: "cover",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 60,
                                  // background: "transparent",
                                }}
                              >
                                <p
                                  className="gameTitle"
                                  style={{
                                    padding: 10,
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                                <span
                                  className="gameDetailInfo"
                                  data-game-name="빅 배스 보난자"
                                  data-game-detail="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                                  langkey="col.reminders"
                                >
                                  유의사항
                                </span>
                              </div>
                              <div
                                className="layer_item_set"
                                style={{
                                  top: "1px",
                                  left: "1px",
                                  display: "none",
                                }}
                              >
                                <div className="thumb" id="test22">
                                  {" "}
                                  <a
                                    style={{
                                      background:
                                        "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                      backgroundSize: "100%",
                                    }}
                                  >
                                    <img
                                      src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                      style={{
                                        width: "218px",
                                        height: "218px",
                                      }}
                                      className="item_img"
                                    />{" "}
                                  </a>
                                </div>
                                <div
                                  className="gameLinkArea"
                                  data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-new-window=""
                                ></div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMobile() ? <MobileFootbar /> : <Footbar />}
        </div>
        <div
          className=" align-items-center  justify-content-center slot-modal-back"
          style={{ display: !openModal ? "none" : "flex" }}
        >
          <div
            className="justify-content-center slot-modal game_list"
            style={{ listStyleType: "none" }}
          >
            <button
              data-v-57fde08a=""
              className="btn_close"
              onClick={onClickCloseModal}
            >
              <i
                data-v-57fde08a=""
                className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close"
                style={{ fontStyle: "normal" }}
              ></i>
            </button>
            <div className="slot-search ">
              {/* <label className="slot-search-label">검색</label> */}
              <input
                className="slot-search-input "
                name="search"
                type="text"
                placeholder={
                  isEmpty(window.lang["검색"]) ? "검색" : window.lang["검색"]
                }
                value={search}
                onChange={onChange}
              />
            </div>
            <div className="w-100 h-100 overflow-auto">
              <ul
                className="slot_list justify-content-center flex-wrap"
                style={{ width: "100%" }}
              >
                {gameLists
                  .filter((list) => {
                    const patt = new RegExp(search, "i");
                    return (
                      patt.test(getTitle(list, props.language)) ||
                      isEmpty(search)
                    );
                  })
                  .map((list, index) => {
                    const imgIndex = imgLists.findIndex(
                      (img) => img.src === list.image
                    );
                    return (
                      <li
                        key={index}
                        style={{ listStyleType: "none", marginBottom: "30px_" }}
                      >
                        <a
                          style={{ backgroundColor: "#0f1621" }}
                          onClick={() => onClickList(list)}
                        >
                          <img
                            data-v-3348b8aa=""
                            className="slot-default-img"
                            src={imgLists[imgIndex].src}
                            alt=""
                            style={{ borderRadius: "10%", minWidth: "145px_" }}
                          />
                        </a>
                        <p className="text-center" style={{ color: "white" }}>
                          {getTitle(list, props.language)}
                        </p>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user.data,
  language: state.more.language,
});

export default connect(mapStateToProps, { SetPageLoading })(Slot);



// WEBPACK FOOTER //
// ./src/containers/Slot/Slot.js